// Shared calculation math: areas, waste factors, unit conversion.
// All calculators build on these. Pure functions, no side effects.

export type UnitSystem = 'imperial' | 'metric'

export const FT_PER_M = 3.280839895
export const SQM_PER_SQFT = 0.09290304

/** Convert a linear measure entered in the active unit system to feet. */
export function toFeet(value: number, system: UnitSystem): number {
  return system === 'imperial' ? value : value * FT_PER_M
}

/** Convert a square measure to sq ft. */
export function toSqFt(value: number, system: UnitSystem): number {
  return system === 'imperial' ? value : value / SQM_PER_SQFT
}

export function rectArea(width: number, length: number): number {
  return Math.max(0, width) * Math.max(0, length)
}

/** Wall area from room footprint + ceiling height. */
export function wallAreaFromRoom(width: number, length: number, height: number): number {
  const perimeter = 2 * (Math.max(0, width) + Math.max(0, length))
  return perimeter * Math.max(0, height)
}

export function applyWaste(area: number, wastePct: number): number {
  return area * (1 + Math.max(0, wastePct) / 100)
}
